import { isMobileOnly } from 'react-device-detect';
import { useTheme } from '@mui/material';
import { colors } from '@constants/colors';

import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    tabs: {
      paddingTop: 0,
      background: 'transparent',
      minHeight: 0,
      borderBottom: `1px solid ${colors.white}`,
      height: isMobileOnly ? '27px' : '29px',
      '& .MuiTabs-scroller': {
        display: 'flex',
        paddingBottom: 1,
      },
      '& .MuiTabs-flexContainer': {
        display: 'inline-flex',
        columnGap: 4,
        width: '100%',
        height: 'fit-content',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: colors.white,
        height: '3px',
      },
    },
    tab: {
      color: colors.grey_300,
      minHeight: 0,
      minWidth: 'fit-content',
      fontWeight: 500,
      p: 0,
      height: 'fit-content',

      '&.Mui-selected': {
        color: colors.white,
        opacity: 1,
        fontWeight: 600,
      },
    },
  };
};
